import Vue from 'vue';
import MyComponents from '~/components/my';
Vue.use(MyComponents);
